import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function equal(
  a: Observable<unknown>,
  b: Observable<unknown>,
): Observable<boolean> {
  return combineLatest([a, b]).pipe(
    map(([valueA, valueB]) => valueA === valueB),
  );
}

export function not(a: Observable<boolean>) {
  return a.pipe(map((valueA) => !valueA));
}

export function greater(
  a: Observable<unknown>,
  b: Observable<unknown>,
): Observable<boolean> {
  return combineLatest([a, b]).pipe(
    map(([valueA, valueB]: [number, number]) => valueA > valueB),
  );
}

export function greaterEqual(
  a: Observable<unknown>,
  b: Observable<unknown>,
): Observable<boolean> {
  return combineLatest([a, b]).pipe(
    map(([valueA, valueB]: [number, number]) => valueA >= valueB),
  );
}

export function smaller(
  a: Observable<unknown>,
  b: Observable<unknown>,
): Observable<boolean> {
  return combineLatest([a, b]).pipe(
    map(([valueA, valueB]: [number, number]) => valueA < valueB),
  );
}

export function smallerEqual(
  a: Observable<unknown>,
  b: Observable<unknown>,
): Observable<boolean> {
  return combineLatest([a, b]).pipe(
    map(([valueA, valueB]: [number, number]) => valueA <= valueB),
  );
}

export function and(...rest: Observable<boolean>[]) {
  return combineLatest(rest).pipe(map((args) => args.every(Boolean)));
}

export function or(...rest: Observable<boolean>[]) {
  return combineLatest(rest).pipe(map((args) => args.some(Boolean)));
}

export function inFunc(
  a: Observable<unknown>,
  b: Observable<unknown>,
): Observable<boolean> {
  return combineLatest([a, b]).pipe(
    map(
      ([valueA, valueB]: [unknown, unknown[]]) => valueB.indexOf(valueA) > -1,
    ),
  );
}
